module.exports = __webpack_public_path__ + "img/face.e2fa8b55.png";